import { WarningAmImage } from '@approvalmax/ui';
import { Button, Flex, Text } from '@approvalmax/ui/src/components';
import { FC, memo, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useLogout } from 'shared/hooks/useLoguot';
import { getDefaultPath } from 'urlBuilder';

import { messages } from './LogoutAcceptInvitation.messages';
import { LogoutAcceptInvitationProps } from './LogoutAcceptInvitation.types';

export const LogoutAcceptInvitation: FC<LogoutAcceptInvitationProps> = memo(({ onLogout }) => {
    const { logout } = useLogout();

    const handleLogout = useCallback(() => {
        logout();
        onLogout();
    }, [logout, onLogout]);

    return (
        <Flex direction='column' alignItems='center' spacing='24'>
            <WarningAmImage width={100} height={100} />

            <Text font='headline' fontSize='xsmall' fontWeight='medium'>
                {messages.title}
            </Text>

            {messages.text}

            <Flex>
                <Button color='midnight80' as={Link} to={getDefaultPath()}>
                    {messages.stayLoggedIn}
                </Button>

                <Button color='blue80' onClick={handleLogout}>
                    {messages.logout}
                </Button>
            </Flex>
        </Flex>
    );
});

LogoutAcceptInvitation.displayName = 'LogoutAcceptInvitation';
